import * as styles from './index.module.css'

export default function TitleInfo({ title, info, capacity, fullWidth, children, disabledDescription }) {
  return (
    <div className={fullWidth ? styles.fullWidth : ''}>
      <div className={styles.title}>
        {title}
        {capacity && <div className={styles.capacityWrapper}><div className={styles.separator}></div>
          <img src={`/app/themes/taxi-stockholm/static/img/option-icons/User.png`} className={styles.capacity} /><span className={styles.capacityNumber}>{capacity}</span> 
        </div>}
      </div>
      {info && <div className={styles.info}>{info}</div>}
      {children}
      {disabledDescription && <div className={styles.disableOption}>{disabledDescription}</div>}
    </div>
  )
}
